/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Autoplay, EffectFade, Pagination } from "swiper";
Swiper.use([Navigation, Autoplay, EffectFade, Pagination]);
import customEventsNames from './../customEventsNames';
export function slider() {
    const latestArticlesSliderSelector = ".cards.swiper";
    const latestNewsSliderSelector = ".articles-section__inner.swiper";
    const boxSliderSelector = ".image-item__text.swiper";
    const customerLogosSliderSelector = ".customer-logos__slider";
    const productRangeSliderSelector = ".cards__slider"; 

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Articles sliders
        const articlesSlider = [];
        const articlesSliderElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (articlesSliderElements) {
            articlesSliderElements.forEach(slider => {

                articlesSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    breakpoints: {
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 960px
                        960: {
                            slidesPerView: 3,
                        }
                    },
                    spaceBetween: 40,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Latest news sliders
        const latestNewsSliders = [];
        const latestNewsSlidersElements = document.querySelectorAll(latestNewsSliderSelector);
        if (latestNewsSlidersElements) {
            latestNewsSlidersElements.forEach(slider => {

                latestNewsSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Dropdown boxes sliders
        const boxSlider = [];
        const boxSliderElements = document.querySelectorAll(boxSliderSelector);
        if (boxSliderElements) {
            boxSliderElements.forEach(slider => {

                boxSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.19,
                    navigation: {
                        nextEl: ".dropdown-boxes__slider-next",
                        prevEl: ".dropdown-boxes__slider-prev",
                    },
                     spaceBetween: 20,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Customer Logo sliders
        const customerLogosSlider = [];
        const customerLogosSliderElements = document.querySelectorAll(customerLogosSliderSelector);
        if (customerLogosSliderElements) {
            customerLogosSliderElements.forEach(slider => {

                customerLogosSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: true,
                    slidesPerView: 3,
                    breakpoints: {
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 3,
                        },
                        // when window width is >= 960px
                        960: {
                            slidesPerView: 5,
                        }
                    },
                    spaceBetween: 40,
                    navigation: {
                        nextEl: ".customer-logos__slider-next",
                        prevEl: ".customer-logos__slider-prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        // Product Range Slider
        const productRangeSlider = [];
        const productRangeSliderElements = document.querySelectorAll(productRangeSliderSelector);
        if (productRangeSliderElements) {
            productRangeSliderElements.forEach(slider => {

                productRangeSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    // width: 1050,
                    shortSwipes: false,
                    slidesPerView: 3,
                    breakpoints: {
                        // when window width is >= 480px
                        300: {
                            slidesPerView: 1,
                            width: 325,
                        },
                        // when window width is >= 960px
                        960: {
                            slidesPerView: 3,
                        }
                    },
                    spaceBetween: 40,
                    navigation: {
                        nextEl: ".slider-navigation__next",
                        prevEl: ".slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

    };

    init();
}
